// DoneStep.tsx — step 'done' del onboarding.
// Qué hace: muestra el botón final que entrega el workspace creado y cierra el modal.
// Qué exporta: DoneStep.
// Quién lo usa: CreateWorkspaceModal.

import { Workspace } from '@agency-smm/shared';
import { Button } from '../../Button';
import { SuccessBox } from '../styled';

interface Props {
  createdWs: Workspace;
  onCreated: (workspace: Workspace) => void;
  handleClose: () => void;
}

export function DoneStep({ createdWs, onCreated, handleClose }: Props) {
  return (
    <SuccessBox>
      <Button type="button" onClick={() => { onCreated(createdWs); handleClose(); }} style={{ width: '100%' }}>
        Go to Workspace
      </Button>
    </SuccessBox>
  );
}
